import { createV3Queries } from "@query/utils/createV3Queries";
import { payeeRowsApi } from "@api";

/**
 * v3 registry for the payer-seat contractor search rows
 * (`GET /v3/search/payee-rows`) — the denormalized, materialized row that backs
 * the contractors list/table. This is the v3 twin of the v1 search-service
 * `/search/payee-row`: cursor pagination + the full legacy filter surface
 * (search string, engagement/requirements/TIN status, autopay, tax-share,
 * batches, per-requirement flags), returning a `PayeeRow` that carries the
 * columns the table renders.
 */
export const queriesPayeeRows = createV3Queries("payeeRowsApi", payeeRowsApi);
